"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _material = require("@mui/material");
var _functions = require("../../@functions");
var _hooks = require("../../@hooks");
var _apis = require("../../@apis");
var _constants = require("../../@constants");
var _env = require("../../@constants/env");
var _TabContext = require("./contexts/TabContext");
var _AuthContext = require("./contexts/AuthContext");
var _ExternalAuthContext = require("./contexts/ExternalAuthContext");
var _google = require("@react-oauth/google");
var _Loader = _interopRequireDefault(require("../Loader"));
var _ChoosePortal = _interopRequireDefault(require("../ChoosePortal"));
require("../../@assets/sass/components/Auth.scss");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/**
 * @typedef AuthPageProps
 * @type {import("./contexts/AuthContext").AuthPageProps}
 */

/** @returns {JSX.Element} */
function Auth() {
  var _useAuth = (0, _AuthContext.useAuth)(),
    app = _useAuth.app,
    urlProps = _useAuth.urlProps,
    hideSpinner = _useAuth.hideSpinner,
    showSpinner = _useAuth.showSpinner,
    goToPage = _useAuth.goToPage,
    loginWithSSO = _useAuth.loginWithSSO,
    auth = _useAuth.auth;
  var _useContext = (0, _react.useContext)(_TabContext.TabContext),
    coverSrc = _useContext.coverSrc,
    coverLoaded = _useContext.coverLoaded,
    TabComponent = _useContext.TabComponent,
    tabProps = _useContext.tabProps,
    setTab = _useContext.setTab;
  var _useExternalAuth = (0, _ExternalAuthContext.useExternalAuth)(),
    external = _useExternalAuth.external,
    loading = _useExternalAuth.loading;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    showCover = _useState2[0],
    setShowCover = _useState2[1];
  var recoveryToken = urlProps.params.recoveryToken;
  var isPortal = app === 'workflux-portal';
  var logoSrc = _constants.logosImages[app].logo;
  var logoAlt = _constants.logosImages[app].logoAlt;
  var coverAlt = _constants.logosImages[app].coverAlt;

  /** @param {string} token */
  var rememberSession = function rememberSession(token) {
    showSpinner();
    loginWithSSO(token)["catch"](function () {
      showSpinner();
      _apis.appcenterApi.auth.createSSOTokenFromToken(token).then(function (_ref) {
        var data = _ref.data;
        return data.uid;
      }).then(function (token) {
        (0, _functions.setRememberMeToken)(app, token);
        rememberSession(token);
      })["finally"](hideSpinner);
    })["finally"](hideSpinner);
  };
  (0, _react.useEffect)(function () {
    if (auth.isAuthenticated) return goToPage('/');

    /*const token = getRememberMeToken(app);
    if (token) rememberSession(token);*/
  }, [auth, app]);
  (0, _react.useEffect)(function () {
    if (recoveryToken) setTab('redefinePassword', {
      recoveryToken: recoveryToken
    });
  }, [recoveryToken]);
  (0, _react.useEffect)(function () {
    setShowCover(false);
  }, [coverSrc]);
  (0, _hooks.useTimeout)(function () {
    if (!showCover) setShowCover(true);
  }, 200, [showCover]);
  if (loading && isPortal) return /*#__PURE__*/_react["default"].createElement(_Loader["default"], {
    loading: loading,
    title: "Carregando tela..."
  });
  if (!external && isPortal) {
    return /*#__PURE__*/_react["default"].createElement(_ChoosePortal["default"], null);
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "Auth ".concat(app),
    "data-app": app
  }, /*#__PURE__*/_react["default"].createElement("aside", {
    className: "Auth-left"
  }, /*#__PURE__*/_react["default"].createElement("header", {
    className: "Auth-left-header"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    className: "Auth-left-header-logo",
    "data-portal": app === 'workflux-portal',
    src: logoSrc,
    alt: logoAlt,
    draggable: false
  })), showCover && coverLoaded && /*#__PURE__*/_react["default"].createElement("img", {
    className: "Auth-left-cover",
    src: coverSrc,
    alt: coverAlt,
    draggable: false
  })), /*#__PURE__*/_react["default"].createElement("aside", {
    className: "Auth-right"
  }, /*#__PURE__*/_react["default"].createElement(TabComponent, tabProps)));
}

/**
 * @typedef AuthPageProps
 * @type {import("./contexts/AuthContext").AuthPageProps}
 */

/**
 * @param {AuthPageProps} props
 * @returns {JSX.Element}
 */
var AuthPage = function AuthPage(props) {
  var app = props.app;
  var color = _constants.colors[app];
  var theme = (0, _material.createTheme)({
    palette: {
      primary: {
        main: color
      },
      secondary: {
        main: color
      }
    }
  });
  return /*#__PURE__*/_react["default"].createElement(_material.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react["default"].createElement(_TabContext.TabProvider, {
    app: props.app,
    auth: props.auth
  }, /*#__PURE__*/_react["default"].createElement(_google.GoogleOAuthProvider, {
    clientId: _env.googleClientID
  }, /*#__PURE__*/_react["default"].createElement(_AuthContext.AuthProvider, props, /*#__PURE__*/_react["default"].createElement(_ExternalAuthContext.ExternalAuthProvider, props, /*#__PURE__*/_react["default"].createElement(Auth, null))))));
};
AuthPage.propTypes = {
  app: _propTypes["default"].string.isRequired,
  auth: _propTypes["default"].any.isRequired
};
var _default = AuthPage;
exports["default"] = _default;